import { getSchedule } from '../../services/data';
import { types } from '../../types';
import errorException from '@/helpers/errorException';

export const schedule = {
  async openSchedulePage({ dispatch, commit }, payload) {
    try {
      if (!this.state.data.cities) {
        if (payload) {
          await dispatch('getTheatresByCity', payload);
        } else {
          await dispatch('getCitiesWithTheatres');
        }
      }
    } catch (e) {
      errorException(e, commit, 'openSchedulePage');
      return { success: false, error: e.message };
    } finally {
      commit(types.SET_LOADING, { openSchedulePage: false });
    }
  },

  async getSchedule({ commit, getters }, payload) {
    commit(types.SET_LOADING, { getSchedule: true });
    try {
      const userSessionId = getters.getUserSessionId;

      const schedule = await getSchedule({ cityId: payload }, userSessionId);
      commit(types.SET_SCHEDULE, schedule);
    } catch (e) {
      errorException(e, commit, 'getSchedule');
      return { success: false, error: e.message };
    } finally {
      commit(types.SET_LOADING, { getSchedule: false });
    }
  },
};
